import React, { useEffect, useContext, useState } from "react";
import api, { API_URL, showAlert, AuthContext, toNaira } from "../util/api";
import { Link, useNavigate } from "react-router-dom";
import PatientTable from "./patienttable";
import PremiumLoader from "../loading";
import NoData from "../components/nodata";

export default function DashboardDetails() {
  const { User, token, Patient } = useContext(AuthContext);
  const router = useNavigate();

  const [balance, setBalance] = useState(0);
  const [ongoing, setOngoing] = useState(0);
  const [completed, setCompleted] = useState(0);
  const [appointments, setAppointments] = useState([]);
  const [medicalHistory, setMedicalHistory] = useState(0);
  const [loading, setLoading] = useState(true);
  const [hovered, setHovered] = useState(null);

  // Fetch data
  const getData = async () => {
    try {
      const response = await api.get(`${API_URL}/patient-info`);
      if (response.data.status === "success") {
        const info = response.data;
        
        setAppointments(info.appointments.data);
        setOngoing(info.ongoing_appointment);
        setCompleted(info.completed_appointment);
        setMedicalHistory(info.medical_history);
        setBalance(info.wallet.balance);
      } else {
        showAlert("error", "Error!", response.data.message);
      }
    } catch (err) {
      showAlert("error", "Error!", "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!User || !token) router("/login");
    if (!Patient) router("/");
    getData();
  }, []);

  // NEW STYLES
  const styles = {
    container: {
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "30px",
      fontFamily: "'Inter', sans-serif",
      background: "#f4f6fa",
      minHeight: "100vh",
    },
    topCards: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "20px",
    },
    card: {
      background: "linear-gradient(145deg, #ffffff, #e6ebf7)",
      borderRadius: "15px",
      padding: "25px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
      transition: "all 0.3s ease",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    cardHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
    },
    cardHeader: {
      fontSize: "1.1rem",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "15px",
    },
    statLabel: {
      fontSize: "0.9rem",
      color: "#7f8c8d",
      marginBottom: "8px",
    },
    statValue: {
      fontSize: "1.4rem",
      fontWeight: "700",
      color: "#34495e",
    },
    tableContainer: {
      borderRadius: "15px",
      overflow: "hidden",
      background: "#fff",
      boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
    },
  };

  return (
    <div style={styles.container}>
      {/* Top Cards */}
      <div style={styles.topCards}>
        {[
          { label: "Wallet Balance", value: toNaira(balance), link: "/transactions" },
          { label: "Ongoing Appointments", value: ongoing, link: "/patient-ongoing-appointments" },
          { label: "Completed Appointments", value: completed, link: "/patient-completed-appointments" },
          { label: "Medical History", value: medicalHistory, link: `/consultation-history/${User?.id}` },
        ].map((item, index) => (
          <Link to={item.link} key={index} style={{ textDecoration: "none" }}>
            <div
              style={{
                ...styles.card,
                ...(hovered === index ? styles.cardHover : {}),
              }}
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={styles.cardHeader}>{item.label}</div>
              <div style={styles.statValue}>{item.value}</div>
            </div>
          </Link>
        ))}
      </div>

      {/* Appointments Table */}
      <div
        style={{
          ...styles.tableContainer,
          ...(hovered === "table" ? styles.cardHover : {}),
        }}
        onMouseEnter={() => setHovered("table")}
        onMouseLeave={() => setHovered(null)}
      >
        <div style={{ ...styles.cardHeader, padding: "20px" }}>Recent Appointments</div>
        {loading ? <PremiumLoader /> : appointments.length > 0 ? (
          <PatientTable appointments={appointments} />
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
}
